import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import PopupVillage from './PopupVillage';
import { FORM_VALUES } from '../../../utils/helpers/constants';

const SelectVillage = ({
  setInitCoordinates,
  villagePopupIsOpen,
  toggleHandlerVillage
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const selectedVillage = values[FORM_VALUES.villageName];

  return (
    <div>
      <Field name={FORM_VALUES.villageId} component="input" type="hidden" />
      <div
        role="button"
        tabIndex="0"
        onClick={toggleHandlerVillage}
        onKeyPress={toggleHandlerVillage}
        className="new-search__locations_row rotate-icon"
      >
        {selectedVillage ? (
          <div className="new-search__locations_label">
            <div className="city__label">{t('new_ad.village')}</div>
            <div className="new-search__locations_names">{selectedVillage}</div>
          </div>
        ) : (
          <div className="new-search__locations_placeholder">
            {t('new_ad.village')}
          </div>
        )}
      </div>
      <PopupVillage
        isOpen={villagePopupIsOpen}
        popupTitle={t('new_ad.village')}
        closeHandler={toggleHandlerVillage}
        setInitCoordinates={setInitCoordinates}
        inputPlaceholder={t('new_ad.find_village')}
      />
    </div>
  );
};

SelectVillage.propTypes = {
  setInitCoordinates: PropTypes.func.isRequired,
  villagePopupIsOpen: PropTypes.bool.isRequired,
  toggleHandlerVillage: PropTypes.func.isRequired
};

export default memo(SelectVillage);
